import { ReactNode } from 'react'

import { Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'

export type ChatContainerProps = {
  header: ReactNode
  onClose?: () => void
} & BoxProps

export const ChatContainer = ({
  header,
  children,
  styles,
  classNames,
  className,
  ...boxProps
}: ChatContainerProps) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'AIChatBotWidget__ChatContainer',
    styles,
    classNames,
  })
  return (
    <Box className={cx(className, classes.root)} {...boxProps}>
      {header && <Box className={classes.header}>{header}</Box>}
      <Box className={classes.body}>{children}</Box>
    </Box>
  )
}
